module.exports = __webpack_public_path__ + "static/media/bullet_gestor.ed448651.png";